// import React from 'react'
import "../Styles/Contact.css"
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_6cjl7dg', 'template_53uuyya', form.current, 'GOfJ0x0FDljEKyk9f')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };

    return (
        <div id="contacts" className="vimp">
            
                <h1 className="contact-heading">Let's Be In Touch 🤝</h1>
                <div className="contact">
            <div className='dev-left'>
                <img  src="https://ibst.in/demanddevelopers/assets/images/13.gif" alt="" />
            </div>
            
           <div className="dev-right">
           <form ref={form} onSubmit={sendEmail}>
                <div className='input'>
                    <input type="text" name="user_name" placeholder='  Your Name' />

                    <input type="email" name="user_email" placeholder='  Email' />
                </div>
                <div className="message">
                    <textarea name="message" placeholder='  Message' />
                </div>
                <div id="btn_div">
                <input className="btnemail" type="submit" value="Send" />
                </div>
               
            </form>
           </div>
            </div>
        </div>
    );
};
export default Contact